<template>
  <div class="text-body-1 text-md-h6" :class="{ 'text-md-center': center }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "MainText",
  props: {
    center: {
      type: Boolean,
      default() {
        return false;
      }
    }
  }
};
</script>
